import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import { Card, CardBody, Alert, Badge } from 'reactstrap';
import axios from 'axios';

const Cst_Cancellations = () => {
    const [showloader, setshowloader] = useState(true);
    const [alertMsgg, setAlertMsgg] = useState<any>({ 
        open: false, 
        type: "success", 
        content: "Messages here." 
    });
    const [cancellations, setCancellations] = useState<any[]>([]);

    const handleAlertMsggClose = () => {
        setAlertMsgg({ ...alertMsgg, open: false });
    };

    const fetchCancellations = async () => {
        try {
            setshowloader(true);
            const response = await axios.get(
                '/payments/customer/cancellations/',
                { withCredentials: true }
            );
            
            if (response.data.status === 'SENT') {
                setCancellations(response.data.cancellations);
            }
            setshowloader(false);
        } catch (error: any) {
            console.error('Error fetching cancellations:', error);
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ 
                        ...alertMsgg, 
                        open: true, 
                        content: error.response.data?.error || 'Error occurred', 
                        type: 'error' 
                    });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ 
                        ...alertMsgg, 
                        open: true, 
                        content: 'Session expired!', 
                        type: 'error' 
                    });
                    setTimeout(() => { window.location.href = '/logout'; }, 2000);
                } else {
                    setAlertMsgg({ 
                        ...alertMsgg, 
                        open: true, 
                        content: 'An error occurred', 
                        type: 'error' 
                    });
                }
            } else {
                setAlertMsgg({ 
                    ...alertMsgg, 
                    open: true, 
                    content: 'Network error', 
                    type: 'error' 
                });
            }
            setshowloader(false);
        }
    };

    useEffect(() => {
        fetchCancellations();
    }, []);

    const formatDate = (dateStr: string) => {
        if (!dateStr) return '-';
        const d = new Date(dateStr);
        return d.toLocaleDateString(undefined, { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getStatusBadge = (status: string) => {
        switch (status) {
            case 'requested':
                return <Badge color="warning">Requested</Badge>;
            case 'processing':
                return <Badge color="info">Processing</Badge>;
            case 'completed':
                return <Badge color="success">Completed</Badge>;
            case 'rejected':
                return <Badge color="danger">Rejected</Badge>;
            default:
                return <Badge color="secondary">{status}</Badge>;
        }
    };

    const getTypeBadge = (type: string) => {
        switch (type) {
            case 'subscription_cancel':
                return <Badge color="primary">Subscription Cancel</Badge>;
            case 'refund_request':
                return <Badge color="info">Refund Request</Badge>;
            default:
                return <Badge color="secondary">{type}</Badge>;
        }
    };

    const PRODUCT_TYPE_LABELS: Record<string, string> = {
        plan: 'Plan/Package',
        planoptionals: 'Optional',
        addon: 'Add-On',
        subscriptionaddon: 'Subscription',
        onetimeproduct: 'Product/Service',
    };

    const REASON_LABELS: Record<string, string> = {
        changed_mind: 'Changed my mind',
        found_alternative: 'Found a better alternative',
        too_expensive: 'Too expensive',
        not_expected: 'Not what I expected',
        technical_issues: 'Technical issues',
        poor_service: 'Poor customer service',
        no_longer_needed: 'No longer needed',
        accidental_purchase: 'Accidental purchase',
        duplicate_order: 'Duplicate order',
        service_not_described: 'Service not as described',
        other: 'Other',
    };

    document.title = 'My Cancellations | BizServe';

    return (
        <div className="page-content">
            {alertMsgg.open && (
                <Alert
                    color={alertMsgg.type === 'success' ? 'success' : 'danger'}
                    toggle={handleAlertMsggClose}
                    fade={false}
                    style={{ fontWeight: 'bold' }}
                >
                    {alertMsgg.content}
                </Alert>
            )}

            <div className="loaderContainer" hidden={!showloader}>
                <div className="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

            <div className="container-fluid px-0 px-md-3 py-3" style={{ minHeight: '90vh' }}>
                <Breadcrumbs title="Customer" breadcrumbItem="My Cancellations" />
                
                <Card className="rounded-4 border-0 shadow-lg bg-white">
                    <CardBody className="p-4">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h5 className="mb-1 fw-bold">Cancellation Requests</h5>
                                <p className="text-muted mb-0">Total: {cancellations.length} request(s)</p>
                            </div>
                        </div>

                        {cancellations.length === 0 && !showloader ? (
                            <div className="text-center py-5">
                                <div className="avatar-lg mx-auto mb-4">
                                    <div className="avatar-title bg-soft-primary text-primary rounded-circle">
                                        <i className="bx bx-info-circle font-size-40"></i>
                                    </div>
                                </div>
                                <h5 className="text-muted">No cancellation requests</h5>
                                <p className="text-muted">You haven't submitted any cancellation requests yet.</p>
                            </div>
                        ) : (
                            <div className="cancellations-list">
                                {cancellations.map((cancellation: any, idx: number) => (
                                    <div key={cancellation.id || idx} className="mb-4 p-4 rounded-4 shadow-sm" style={{ background: 'linear-gradient(120deg, #fef3c7 60%, #fde68a 100%)', border: '1px solid #fde68a' }}>
                                        {/* Cancellation Header */}
                                        <div className="d-flex flex-wrap align-items-start justify-content-between mb-3 pb-3 border-bottom border-warning">
                                            <div>
                                                <div className="d-flex align-items-center gap-2 mb-2">
                                                    <h6 className="mb-0 fw-bold">Cancellation #{cancellation.id}</h6>
                                                    {getStatusBadge(cancellation.status)}
                                                    {getTypeBadge(cancellation.cancellation_type)}
                                                </div>
                                                <div className="text-muted small">
                                                    Order ID: <span className="fw-semibold">{cancellation.order_id}</span>
                                                </div>
                                                <div className="text-muted small">
                                                    UUID: <span className="font-monospace small">{cancellation.order_uuid}</span>
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <div className="text-muted small">Requested</div>
                                                <div className="fw-semibold">{formatDate(cancellation.requested_at)}</div>
                                                {cancellation.processed_at && (
                                                    <>
                                                        <div className="text-muted small mt-2">Processed</div>
                                                        <div className="fw-semibold">{formatDate(cancellation.processed_at)}</div>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        {/* Cancellation Reason */}
                                        <div className="mb-3 p-3 rounded bg-white">
                                            <div className="text-muted small fw-semibold mb-1">Cancellation Reason:</div>
                                            <div className="fw-semibold">{REASON_LABELS[cancellation.reason] || cancellation.reason}</div>
                                            {cancellation.custom_reason && (
                                                <div className="text-muted fst-italic mt-1">"{cancellation.custom_reason}"</div>
                                            )}
                                        </div>

                                        {/* Cancellation Notes */}
                                        {cancellation.notes && (
                                            <div className="mb-3 p-3 rounded bg-white">
                                                <div className="text-muted small fw-semibold mb-1">Your Notes:</div>
                                                <div>{cancellation.notes}</div>
                                            </div>
                                        )}

                                        {/* Cancelled Items */}
                                        {cancellation.items && cancellation.items.length > 0 && (
                                            <div>
                                                <div className="fw-semibold mb-2">Cancelled Items:</div>
                                                <div className="table-responsive">
                                                        <table className="table table-bordered table-sm align-middle mb-0 bg-white">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th>Product</th>
                                                                    <th>Type</th>
                                                                    <th className="text-center">Quantity</th>
                                                                    <th className="text-end">Refund Amount</th>
                                                                    <th className="text-center">Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {cancellation.items.map((item: any, itemIdx: number) => (
                                                                    <tr key={item.id || itemIdx}>
                                                                        <td className="fw-semibold">{item.product_title}</td>
                                                                        <td>
                                                                            <Badge color="info" className="text-dark">
                                                                                {PRODUCT_TYPE_LABELS[item.product_type] || item.product_type}
                                                                            </Badge>
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <Badge color="secondary">{item.quantity_to_cancel}</Badge>
                                                                        </td>
                                                                        <td className="text-end fw-semibold text-success">
                                                                            ${item.refund_amount?.toFixed(2) || '0.00'}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {getStatusBadge(item.line_status)}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                </div>
                                            </div>
                                        )}

                                        {/* Total Refund */}
                                        <div className="mt-3 pt-3 border-top border-warning">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="fw-semibold">Total Potential Refund:</span>
                                                <span className="fw-bold text-success fs-5">
                                                    ${cancellation.items?.reduce((sum: number, item: any) => sum + (item.refund_amount || 0), 0).toFixed(2) || '0.00'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </CardBody>
                </Card>
            </div>
        </div>
    );
};

export default Cst_Cancellations;

